import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/revolutionize.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Software Development in Houston?</h2>
            <p>
              When it comes to custom software development in Houston, TekRevol
              stands out as the premier choice for businesses seeking
              cutting-edge solutions. Our commitment to excellence and
              innovation sets us apart.
            </p>
            <p>
              We possess a team of expert software engineers and developers in
              their field. Their knowledge and experience in software
              development ensure that your project is in the hands of
              professionals who understand your unique needs.
            </p>
            <p>
              We don't believe in one-size-fits-all solutions. TekRevol
              specializes in crafting customized software tailored to your
              specific requirements, ensuring that it aligns perfectly with your
              business objectives.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
